export default "__VITE_ASSET__DzcI2_4w__"